import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import React, { useEffect, useState } from "react";
import { getAvisosAnio, getAvisosTodosOperador } from "../../services";
import moment from "moment/moment";
import "moment/locale/es";
import { useSelector } from "react-redux";
import { formatNumber } from "../../utils/formatNumber";
import LineChart from "../../components/LineChart";

const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const usuarioSitae = useSelector((state) => state.user); //"CO0083";
  const [listaAvisos, setListaAvisos] = useState([]);
  const [totalAvisos, setTotalAvisos] = useState([]);
  const [totalAvisosAnio, setTotalAvisosAnio] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [listaAvisos, totalAvisos, totalAvisosAnio] = await Promise.all([
          getAvisosTodosOperador(usuarioSitae),
          getAvisosAnio(usuarioSitae, 0),
          getAvisosAnio(usuarioSitae, 1),
        ]);

        setListaAvisos(listaAvisos);
        setTotalAvisos(totalAvisos);
        setTotalAvisosAnio(totalAvisosAnio);
        console.log("Lista de Avisos:", listaAvisos);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [usuarioSitae]);

  return (
    <Box m="20px">
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="DASHBOARD" subtitle="Bienvenido a su tablero de consultas" />
      </Box>

      {/* GRID & CHARTS */}
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gridAutoRows="140px" gap="20px">
        <Box gridColumn="span 8" gridRow="span 3" backgroundColor={colors.primary[400]} p="20px">
          <Box display="flex" justifyContent="space-between" alignItems="center" mb="20px">
            <Box>
              <Typography variant="h5" fontWeight="600" color={colors.grey[100]}>
                Total Avisos en los últimos 2 años
              </Typography>
              <Typography variant="h3" fontWeight="bold" color={colors.greenAccent[500]}>
                *Avisos pagados y en trámite de pago
              </Typography>
            </Box>
          </Box>

          {/* Ajusta la altura del gráfico */}
          <Box height="calc(100% - 80px)">
            <LineChart data={totalAvisos} data2={totalAvisosAnio} isDashboard={true} />
          </Box>
        </Box>

        <Box gridColumn="span 4" gridRow="span 3" backgroundColor={colors.primary[400]} overflow="auto">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            borderBottom={`4px solid ${colors.primary[500]}`}
            colors={colors.grey[100]}
            p="15px"
          >
            <Typography color={colors.grey[100]} variant="h5" fontWeight="600">
              Avisos Recientes
            </Typography>
          </Box>
          {listaAvisos.map((transaction, i) => (
            <Box key={`${transaction.id}`}>
              <Box
                color={
                  transaction.EstadoAviso === "Pagado (Reportado Banco)"
                    ? colors.greenAccent[500]
                    : transaction.EstadoAviso === "En Tramite de Pago"
                    ? colors.desert[500]
                    : colors.redAccent[500]
                }
                fontWeight="bold"
                textAlign="left"
                justifyContent="space-between"
                p="8px"
              >
                {transaction.EstadoAviso}
              </Box>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                borderBottom={`4px solid ${colors.primary[500]}`}
                p="10px"
              >
                <Box>
                  <Typography color={colors.greenAccent[500]} variant="h5" fontWeight="600">
                    {transaction.id}
                  </Typography>
                  <Typography color={colors.grey[100]}>
                    Emitido: {moment(transaction.FechaEmision).format("DD MMM YYYY")}
                  </Typography>
                </Box>
                <Box color={colors.grey[100]}>
                  <Typography color={colors.grey[100]}>{transaction.CodigoOperador}</Typography>
                  <Typography
                    color={colors.grey[300]}
                    fontStyle="italic"
                    sx={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "150px",
                    }}
                  >
                    {transaction.Operador}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    backgroundColor:
                      transaction.EstadoAviso === "Pagado (Reportado Banco)"
                        ? colors.greenAccent[500]
                        : transaction.EstadoAviso === "En Tramite de Pago"
                        ? colors.desert[500]
                        : colors.redAccent[500],
                    p: "5px 10px",
                    borderRadius: "4px",
                  }}
                >
                  {transaction.Formato}
                  L. {formatNumber(transaction.Monto)}
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard;
